export const getCSRFToken = () => localStorage.getItem('t')
export const saveCSRFToken = (token: string) => localStorage.setItem('t', token)

const JWT_KEY = 'JWT'
export const getJWTToken = () => localStorage.getItem(JWT_KEY)
export const setJWTToken = (jwt: string) => localStorage.setItem(JWT_KEY, jwt)
export const removeJWTToken = () => localStorage.removeItem(JWT_KEY)

// NOTE: 'e' will be removed later when we fully migrate to wallet login SSO
const EXPIRATION_KEY = 'e'
export const getExpirationTime = () => localStorage.getItem(EXPIRATION_KEY)
export const setExpirationTime = (time: string) => localStorage.setItem(EXPIRATION_KEY, time)
export const removeExpirationTime = () => localStorage.removeItem(EXPIRATION_KEY)

type jwtPayload = {
  exp: number // UTC Seconds Number
  iat: number
  iss: string
  jti: string
  userID: string
}

export function decodeJwt(jwtStr: string): jwtPayload | undefined {
  try {
    const base64Url = jwtStr.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`
        })
        .join('')
    )
    return JSON.parse(jsonPayload)
  } catch (e) {
    return undefined
  }
}
